import React from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';
import SuspendedLanding from './features/SuspendedLanding';

const CatchAllRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Redirect to={{ pathname: '/', search }} />;
};

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={SuspendedLanding} />
        <Route render={() => <CatchAllRedirect />} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
